import { React,useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Offcanvas } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"


export default function MenuKitchen() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const handleClose = () =>  setShow(false)
    const handleShow = () => setShow(true)
	const {logout,client} = useAuth()

	const [restaurantId, setRestaurantId] = useState(null)

    useEffect(() => {
        if(client){
            if(client?.restaurant){
                setRestaurantId(client.restaurant)
            }
        }
    },[dispatch, t, client])
  	return (
		<header>
			<div id="avatar" onClick={handleShow} className="d-flex justify-content-center align-items-center">
				<figure className="d-flex justify-content-center align-items-center">
					<i className="fa-solid fa-user fa-2x"></i>
				</figure>
			</div>
			<Offcanvas show={show} onHide={()=>setShow(false)} placement="end">
				<Offcanvas.Header closeButton>
				<Offcanvas.Title className='text-uppercase'><strong>{t('global.menu')}</strong></Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body id='menu'>
					<ul className="list-group">
						<Link to="/kitchen/dashboard" onClick={handleClose}>
							<li className="list-group-item">
								{t('global.home')}							
							</li>
						</Link>
                        <Link to={"/kitchen/ordersfordelivery/"+restaurantId}  onClick={handleClose}>
							<li className="list-group-item">
                            	{t('kitchen.dashboard.ordersfordelivery')}
							</li>
                        </Link>
                        <Link to={"/kitchen/ordersdelivered/"+restaurantId}  onClick={handleClose}>
							<li className="list-group-item">
                            	{t('kitchen.dashboard.ordersdelivered')}
							</li>
                        </Link>
						<Link to="/#" onClick={logout}>
							<li className="list-group-item">
								{t('global.logout')}
							</li>
						</Link>						
					</ul>
				</Offcanvas.Body>
			</Offcanvas>
		</header>
	)
}